import { endpoints } from '../constants/endpoints';
import { sendRequest } from './sendRequest';

export const createLevelUpTaskApi = ({
  checkInInstanceId,
  competencyId,
  levelUpId,
  status,
  uiKey,
  dueTS,
  text,
  toIds,
  teams,
  label,
  uuid,
  employeeId,
}) => {
  const url = endpoints.growth.oneOnOne.levelUpTasks(employeeId);

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      competencyId,
      levelUpId,
    },
    body: {
      checkInInstanceId,
      status,
      uiKey,
      dueTS,
      text,
      toIds,
      teams,
      label,
      uuid,
    },
  });
};

export const updateLevelUpTaskApi = ({
  checkInInstanceId,
  competencyId,
  levelUpId,
  status,
  uiKey,
  dueTS,
  text,
  toIds,
  teams,
  label,
  uuid,
  employeeId,
}) => {
  const url = endpoints.oneOnOne.actionItems.createOrUpdate;

  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      competencyId,
      levelUpId,
    },
    body: {
      checkInInstanceId,
      status,
      uiKey,
      dueTS,
      text,
      toIds,
      teams,
      label,
      uuid,
    },
  });
};

export const getLevelUpTasksApi = ({ competencyId, levelUpId, limit, offset, employeeId }) => {
  const url = endpoints.growth.oneOnOne.levelUpTasks(employeeId);

  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      competencyId,
      levelUpId,
    },
  });
};
